import { render, staticRenderFns } from "./MortgageManagersVacations.vue?vue&type=template&id=704a511e&"
import script from "./MortgageManagersVacations.vue?vue&type=script&lang=js&"
export * from "./MortgageManagersVacations.vue?vue&type=script&lang=js&"
import style0 from "./MortgageManagersVacations.vue?vue&type=style&index=0&id=704a511e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports